// Shared HH:MM <-> minutes helpers. Used anywhere a duration is entered/displayed
// as hours:minutes but stored as a whole-minute count (service times, cache values).

// One side of an HH:MM pair. Blank means the user typed only the other half
// ('1:' / ':30'), which we read as 0. Anything non-numeric fails the whole parse
// rather than silently becoming 0 and producing a wrong-but-plausible duration.
const parseHalf = (part) => {
    const trimmed = part.trim();
    if (trimmed === '') return 0;
    return /^\d+$/.test(trimmed) ? parseInt(trimmed, 10) : null;
};

// Parse "HH:MM" (or a bare minute count) to whole minutes. Returns null when
// empty/invalid/negative so callers can treat "unset" uniformly.
export const parseHHMM = (value) => {
    if (value == null) return null;
    const str = String(value).trim();
    if (str === '') return null;
    if (str.includes(':')) {
        const parts = str.split(':');
        // Exactly one colon, and at least one half filled in.
        if (parts.length !== 2 || parts.every((p) => p.trim() === '')) return null;
        const hours = parseHalf(parts[0]);
        const minutes = parseHalf(parts[1]);
        if (hours == null || minutes == null) return null;
        return hours * 60 + minutes;
    }
    const num = Number(str);
    return Number.isFinite(num) && num >= 0 ? Math.round(num) : null;
};

// Format a whole-minute count as zero-padded "HH:MM". Returns '' for null/invalid,
// so it can seed a text input directly.
export const formatHHMM = (minutes) => {
    if (minutes == null || !Number.isFinite(Number(minutes))) return '';
    const total = Math.max(0, Math.floor(Number(minutes)));
    const hours = Math.floor(total / 60);
    const mins = total % 60;
    return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
};
